import { createBrowserRouter, type RouteObject } from "react-router";
import { AppLayout } from "@/components/layout/app-layout";
import { RequireAuth } from "@/components/layout/require-auth";
import { RequireRole } from "@/components/layout/require-role";
import { AccountPage } from "@/pages/account/account";
import { ChangePasswordPage } from "@/pages/auth/change-password";
import { InvitePage } from "@/pages/auth/invite";
import { LoginPage } from "@/pages/auth/login";
import { ForgotPasswordPage, ResetPasswordPage } from "@/pages/auth/password-reset";
import { SetupTwoFactorPage } from "@/pages/auth/setup-two-factor";
import { TwoFactorPage } from "@/pages/auth/two-factor";
import { HomePage } from "@/pages/home";
import { ErrorPage, InlineErrorPage } from "@/pages/error";
import { NotFoundPage } from "@/pages/not-found";
import { CreditsPage } from "@/pages/public/credits";
import { officeRoutes, adminRoutes } from "@/features/routes";

const pages: RouteObject[] = [
  { path: "/login", element: <LoginPage /> },
  { path: "/login/2fa", element: <TwoFactorPage /> },
  { path: "/setup-2fa", element: <SetupTwoFactorPage /> },
  { path: "/change-password", element: <ChangePasswordPage /> },
  { path: "/invite/:token", element: <InvitePage /> },
  { path: "/forgot-password", element: <ForgotPasswordPage /> },
  { path: "/reset-password", element: <ResetPasswordPage /> },
  { path: "/credits", element: <CreditsPage /> },
  { path: "/about", lazy: () => import("@/pages/public/landing").then((m) => ({ Component: m.LandingPage })) },
  { path: "/services", lazy: () => import("@/pages/public/services").then((m) => ({ Component: m.ServicesPage })) },
  {
    element: <RequireAuth />,
    children: [
      {
        element: <AppLayout />,
        children: [
          {
            // Errors inside a screen show within the frame, so the menu stays usable.
            errorElement: <InlineErrorPage />,
            children: [
              { index: true, element: <HomePage /> },
              { path: "account", element: <AccountPage /> },
              { path: "offices/:officeId", children: officeRoutes },
              { path: "admin", element: <RequireRole roles={["admin"]} />, children: adminRoutes },
              { path: "*", element: <NotFoundPage /> },
            ],
          },
        ],
      },
    ],
  },
];

// One Japanese error screen for every route (render errors, failed screen loads).
const routes: RouteObject[] = [{ errorElement: <ErrorPage />, children: pages }];

export const router = createBrowserRouter(routes);
